import React, { cloneElement } from 'react';
import { Dialog, Box, Typography } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';

interface Props {
  open?: boolean;
  onClose?: any;
  children: any;
  width?: 'md' | 'lg' | 'sm' | 'xs';
  icon?: any;
  description?: any;
  title: string;
  'data-cy'?: string;
  buttons?: any;
  withBackdrop?: boolean;
}

const CustomDialog: React.FC<Props> = ({
  onClose = () => {},
  open = true,
  children,
  width = 'md',
  icon,
  description,
  title,
  'data-cy': dataCy = 'dialog',
  buttons,
  withBackdrop = true,
}) => {
  const theme = useTheme();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={width}
      fullWidth
      data-cy={dataCy}
      BackdropProps={!withBackdrop ? { style: { opacity: 0 } } : undefined}
    >
      <Box style={{ display: 'grid', gridGap: 16, padding: 16 }}>
        <Box
          style={{
            display: 'grid',
            gridTemplateColumns: icon ? 'auto 1fr' : '1fr',
            gridGap: 8,
            alignItems: 'center',
          }}
        >
          {icon &&
            cloneElement(icon, {
              style: {
                ...(icon.props?.style || {}),
                color: theme.palette.primary.main,
              },
            })}

          <Typography
            style={{
              fontSize: '1.5rem',
              fontWeight: 700,
              letterSpacing: '-0.015em',
              color: theme.palette.secondary.main,
            }}
          >
            {title}
          </Typography>
        </Box>

        {description && (
          typeof description === 'string' ? (
            <Typography style={{ fontSize: 14 }}>{description}</Typography>
          ) : (
            <Box style={{ fontSize: 14 }}>{description}</Box>
          )
        )}

        {children}

        {buttons && buttons}
      </Box>
    </Dialog>
  );
};

export default CustomDialog;
